<route>
{
  "meta": {
    "permission": [
      "sequences.view_sequence"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      :title="$tc('sequence', 2)"
      :headers="headers"
      app="sequences.sequence"
      api="sequence"
      dontRemove
      @click:edit="changeRoute"
      @click:create="changeRoute({ pk: 'create' })"
      :opt="isAdmin ? null : { company: this.company.pk }"
    >
      <template v-slot:item.model="{ value }">
        {{ $tc(value, 1) }}
      </template>
      <template v-slot:item.prefix_en="{ value }">
        <span :class="value === '' ? 'red--text' : ''">
          {{ value === '' ? $t('unavailable') : value }}
        </span>
      </template>
      <template v-slot:item.prefix_es="{ value }">
        <span :class="value === '' ? 'red--text' : ''">
          {{ value === '' ? $t('unavailable') : value }}
        </span>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    headers() {
      return [
        {
          text: this.$t('model'),
          value: 'model'
        },
        {
          text: this.$t('prefix_en'),
          value: 'prefix_en'
        },
        {
          text: this.$t('padding'),
          value: 'padding'
        },
        {
          text: this.$t('next_number'),
          value: 'next_number'
        },
        {
          text: this.$t('prefix_es'),
          value: 'prefix_es'
        },
        {
          text: this.$t('number_increment'),
          value: 'number_increment'
        },
        {
          text: this.sequenceBtn.edit ? this.$t('action') : '',
          value: this.sequenceBtn.edit ? 'actions' : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData'
    }),
    sequenceBtn() {
      return {
        edit: this.getPermissions([`sequences.change_sequence`])
      }
    }
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        name: 'sequence-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    }
  }
}
</script>
